export default __webpack_public_path__ + "static/media/7a70754f71d42ba8.7df2eb0c4e5dc6f4f921ee686ca3d237.svg";